// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"LocalContactInfo_wrapper__c1rYH","actions":"LocalContactInfo_actions__EnIQ-","btn":"LocalContactInfo_btn__3r9B1"};